<template>
  <v-footer class="d-flex flex-column footer-block pb-0 pt-14">
    <v-container class="py-0 ma-0 px-4 px-md-15" fluid>
      <v-row justify="space-between">
        <v-col cols="12" sm="5" md="4" lg="3" class="pr-8 pl-1 pl-sm-7 px-md-0 pb-8 pb-md-0">
          <v-row justify="space-between" style="flex-wrap: nowrap;">
            <v-col order="2" order-sm="1" cols="auto" class="px-0">
              <v-btn icon variant="text" href="#top" size="large" height="auto" class="btn-svg-scroll-top">
                <svg width="60" viewBox="0 0 60 107" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" class="svg-path"
                    d="M58.9286 77.3366V29.6634C58.9286 13.8658 45.9768 1.05941 30 1.05941C14.0232 1.05941 1.07143 13.8658 1.07143 29.6634V77.3366C1.07143 93.1342 14.0232 105.941 30 105.941C45.9768 105.941 58.9286 93.1342 58.9286 77.3366ZM30 0C13.4315 0 0 13.2807 0 29.6634V77.3366C0 93.7193 13.4315 107 30 107C46.5685 107 60 93.7193 60 77.3366V29.6634C60 13.2807 46.5685 0 30 0Z"
                    fill="#F6F2E6" />
                  <path fill-rule="evenodd" clip-rule="evenodd" class="svg-path"
                    d="M29.2424 39.5083C29.6608 39.0946 30.3392 39.0946 30.7576 39.5083L37.5761 46.2503C37.9946 46.6641 37.9946 47.3348 37.5761 47.7486C37.1577 48.1623 36.4793 48.1623 36.0609 47.7486L31.0714 42.8151V66.7426C31.0714 67.3277 30.5917 67.802 30 67.802C29.4083 67.802 28.9286 67.3277 28.9286 66.7426V42.8151L23.9391 47.7486C23.5207 48.1623 22.8423 48.1623 22.4239 47.7486C22.0054 47.3348 22.0054 46.6641 22.4239 46.2503L29.2424 39.5083Z"
                    fill="#F6F2E6" />
                </svg>
              </v-btn>
            </v-col>
            <v-col order="1" order-sm="2" cols="auto" align-self="stretch" class=""
              style="display: flex; flex-direction: column;">
              <v-row class="ma-0">
                <v-btn variant="text" size="small" href="https://www.instagram.com/gpartnersco/" target="_blank"
                  class="btn-small">
                  Instagram
                </v-btn>
                <span class="span-line-verticaly">|</span>
                <v-btn variant="text" size="small" href="https://www.facebook.com/Gpartners.invest" target="_blank"
                  class="btn-small">
                  Facebook
                </v-btn>
                <span class="span-line-verticaly">|</span>
                <v-btn variant="text" size="small" href="https://www.linkedin.com/company/gpartnersco/" target="_blank"
                  class="btn-small">
                  LinkedIn
                </v-btn>
              </v-row>
              <div>
                <v-row class="ma-0 px-3 mt-auto">
                  <p class="text-footer-small">
                    {{ t("$vuetify.footer.working_worldwide") }}
                  </p>
                </v-row>
                <v-row class="ma-0 px-3">
                  <p class="text-footer-small">
                    {{ t("$vuetify.footer.based_in_chisinau") }}
                  </p>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="6" v-if="$vuetify.display.sm"></v-col>

        <v-col cols="6" sm="4" md="2" ffsetMd="1" class="px-0">
          <v-list width="100%" size="compact" class="list2">
            <v-list-item value="home" @click="$router.push(GetPath('home'))" class="list2-item">
              <v-list-item-title class="list2-item-title">
                {{ t("$vuetify.header.home") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item value="real_estate" @click="$router.push(GetPath('real-estate'))" class="list2-item">
              <v-list-item-title class="list2-item-title">
                {{ t("$vuetify.header.real_estate") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item value="about" @click="$router.push(GetPath('about'))" class="list2-item">
              <v-list-item-title class="list2-item-title">
                {{ t("$vuetify.header.about") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item value="learn" @click="$router.push(GetPath('learn'))" class="list2-item">
              <v-list-item-title class="list2-item-title">
                {{ t("$vuetify.header.learn") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item value="partners" @click="$router.push(GetPath('partners'))" class="list2-item">
              <v-list-item-title class="list2-item-title">
                {{ t("$vuetify.header.partners") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item value="contact" @click="$router.push(GetPath('contact'))" class="list2-item">
              <v-list-item-title class="list2-item-title">
                {{ t("$vuetify.header.contact") }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="6" sm="4" md="3" class="px-0">
          <v-list width="100%" size="compact" class="list3">
            <v-list-item class="list3-item" v-for="categorie in getAllCategories.slice(0, 8)" :key="categorie.ID"
              @click="SelectCategory(categorie)">
              <v-list-item-title class="list3-item-title">
                {{ categorie[`name_${$vuetify.locale.current}`] }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="6" sm="4" md="3" class="px-0">
          <v-list width="100%" size="compact" class="list3">
            <v-list-item class="list3-item" v-for="item in list4" :key="item.title" @click="OpenLegalPage(item)">
              <v-list-item-title class="list3-item-title">
                {{ t(`$vuetify.footer.${item.title}`) }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="6" sm="4" md="3" class="px-0 mb-0 mb-md-10">
          <v-list width="100%" size="compact" class="list3">
            <v-list-item class="text-gold">
              <v-list-item-title class="text-gold">
                G Partners Invest S.R.L.
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="text-gold" href="https://amark.pro/" target="_blank">
              <v-list-item-title class="text-gold">
                  Website development - amark.pro
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>



      <v-row justify="center">
        <v-col cols="12" class="" style="line-height: 0;">
          <div class="div-blur"></div>
          <svg width="100%" viewBox="0 0 1535 238" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M213.409 239.432H187.383L181.202 211.918C170.358 224.365 159.514 232.99 148.671 237.794C137.827 242.598 125.356 245 111.259 245C93.9086 245 78.2933 241.834 64.4131 235.501C50.7497 228.951 39.1467 220.107 29.604 208.971C20.0613 197.834 12.6874 184.842 7.48232 169.993C2.49411 155.145 0 139.314 0 122.5C0 105.905 2.49411 90.1827 7.48232 75.3342C12.6874 60.4857 20.0613 47.4933 29.604 36.357C39.1467 25.2206 50.7497 16.377 64.4131 9.82619C78.2933 3.2754 93.9086 0 111.259 0C123.838 0 135.766 1.74688 147.044 5.24063C158.539 8.51603 168.732 13.5383 177.624 20.3075C186.516 26.8583 193.89 35.156 199.746 45.2005C205.601 55.2451 209.288 66.8182 210.806 79.9198H171.118C170.033 72.2772 167.647 65.6172 163.961 59.9398C160.49 54.0441 156.044 49.131 150.622 45.2005C145.2 41.27 139.128 38.3222 132.405 36.357C125.681 34.3917 118.633 33.4091 111.259 33.4091C98.8968 33.4091 88.1613 35.9202 79.0524 40.9425C70.1604 45.9648 62.8949 52.7339 57.2561 61.25C51.6172 69.5477 47.3881 79.0463 44.5686 89.746C41.9661 100.446 40.6648 111.364 40.6648 122.5C40.6648 133.636 41.9661 144.554 44.5686 155.254C47.3881 165.954 51.6172 175.561 57.2561 184.078C62.8949 192.375 70.1604 199.035 79.0524 204.057C88.1613 209.08 98.8968 211.591 111.259 211.591C121.669 211.809 130.886 210.499 138.911 207.66C146.936 204.603 153.659 200.345 159.081 194.886C164.72 189.209 168.949 182.331 171.768 174.251C174.588 166.172 176.106 157.219 176.323 147.393H114.512V116.277H213.409V239.432Z"
              fill="#F6F2E6" />
            <path
              d="M242.412 42.7767L247.422 27.8737L272.472 37.7326V10.2192H287.957V37.7326L312.779 27.8737L318.244 42.7767L292.284 51.4893L308.224 73.0414L296.155 81.9833L279.987 59.514L264.501 81.9833L251.749 73.0414L267.689 51.4893L242.412 42.7767Z"
              fill="#F6F2E6" />
            <path
              d="M365.587 5.56817H468.062C484.545 5.56817 497.991 7.97013 508.402 12.7741C518.812 17.578 526.836 23.5829 532.475 30.7888C538.114 37.9946 541.909 45.8556 543.861 54.3717C546.03 62.8877 547.115 70.7486 547.115 77.9545C547.115 85.1604 546.03 93.0214 543.861 101.537C541.909 109.835 538.114 117.587 532.475 124.793C526.836 131.999 518.812 138.004 508.402 142.807C497.991 147.393 484.545 149.686 468.062 149.686H406.252V239.432H365.587V5.56817ZM406.252 116.277H465.785C470.339 116.277 475.002 115.622 479.774 114.311C484.545 113.001 488.882 110.927 492.786 108.088C496.907 105.031 500.16 101.101 502.546 96.2968C505.148 91.2745 506.45 85.0512 506.45 77.627C506.45 69.9844 505.365 63.6519 503.197 58.6297C501.028 53.6074 498.1 49.6769 494.413 46.8382C490.726 43.7812 486.497 41.7068 481.725 40.615C476.954 39.5232 471.858 38.9773 466.436 38.9773H406.252V116.277Z"
              fill="#F6F2E6" />
            <path
              d="M708.47 201.765C708.47 206.35 709.012 209.626 710.097 211.591C711.398 213.556 713.783 214.539 717.254 214.539C718.338 214.539 719.639 214.539 721.157 214.539C722.676 214.539 724.411 214.32 726.362 213.884V239.759C725.061 240.196 723.326 240.633 721.157 241.07C719.205 241.725 717.145 242.27 714.976 242.707C712.808 243.144 710.639 243.471 708.47 243.69C706.301 243.908 704.458 244.017 702.94 244.017C695.349 244.017 689.059 242.489 684.071 239.432C679.083 236.375 675.83 231.025 674.312 223.382C666.938 230.588 657.829 235.829 646.985 239.104C636.358 242.38 626.056 244.017 616.08 244.017C608.489 244.017 601.223 242.926 594.283 240.742C587.343 238.777 581.162 235.829 575.74 231.898C570.535 227.75 566.306 222.618 563.053 216.504C560.016 210.172 558.498 202.857 558.498 194.559C558.498 184.078 560.342 175.561 564.029 169.011C567.932 162.46 572.921 157.328 578.993 153.616C585.283 149.904 592.223 147.284 599.814 145.755C607.621 144.008 615.429 142.698 623.237 141.825C629.96 140.515 636.358 139.641 642.43 139.205C648.503 138.549 653.816 137.567 658.371 136.257C663.142 134.947 666.829 132.981 669.432 130.361C672.251 127.522 673.661 123.373 673.661 117.914C673.661 113.111 672.468 109.18 670.082 106.123C667.914 103.066 665.094 100.773 661.624 99.2446C658.371 97.4978 654.684 96.406 650.563 95.9692C646.443 95.3142 642.539 94.9866 638.852 94.9866C628.442 94.9866 619.875 97.1702 613.152 101.537C606.428 105.905 602.633 112.674 601.765 121.845H564.679C565.33 110.927 567.932 101.865 572.487 94.6591C577.041 87.4532 582.789 81.6666 589.729 77.2994C596.886 72.9322 604.91 69.8752 613.802 68.1283C622.694 66.3815 631.803 65.508 641.129 65.508C649.37 65.508 657.503 66.3815 665.528 68.1283C673.552 69.8752 680.709 72.7139 686.999 76.6444C693.505 80.5749 698.71 85.7063 702.614 92.0388C706.518 98.1528 708.47 105.686 708.47 114.639V201.765ZM671.384 154.599C665.745 158.311 658.805 160.604 650.563 161.477C642.322 162.132 634.08 163.224 625.839 164.753C621.935 165.408 618.14 166.39 614.453 167.701C610.766 168.792 607.513 170.43 604.693 172.614C601.874 174.579 599.597 177.308 597.862 180.802C596.343 184.078 595.584 188.117 595.584 192.921C595.584 197.07 596.777 200.564 599.163 203.402C601.549 206.241 604.368 208.534 607.621 210.281C611.091 211.809 614.778 212.901 618.682 213.556C622.803 214.211 626.49 214.539 629.743 214.539C633.864 214.539 638.31 213.993 643.081 212.901C647.852 211.809 652.298 209.953 656.419 207.333C660.757 204.713 664.335 201.437 667.154 197.507C669.974 193.358 671.384 188.336 671.384 182.44V154.599Z"
              fill="#F6F2E6" />
            <path
              d="M738.615 70.0936H773.424V102.848H774.075C775.159 98.262 777.22 93.7856 780.256 89.4184C783.509 85.0512 787.305 81.1208 791.642 77.627C796.197 73.9149 801.185 70.967 806.607 68.7834C812.029 66.5998 817.559 65.508 823.198 65.508C827.536 65.508 830.464 65.6172 831.982 65.8356C833.717 66.0539 835.452 66.2723 837.187 66.4906V102.52C834.584 102.083 831.873 101.756 829.054 101.537C826.451 101.101 823.849 100.882 821.246 100.882C814.957 100.882 808.993 102.193 803.354 104.813C797.932 107.215 793.16 110.927 789.04 115.949C784.919 120.753 781.666 126.758 779.28 133.964C776.894 141.17 775.702 149.467 775.702 158.857V239.432H738.615V70.0936Z"
              fill="#F6F2E6" />
            <path
              d="M826.309 70.0936H854.286V19.3249H891.373V70.0936H924.88V97.9345H891.373V188.336C891.373 192.266 891.481 195.651 891.698 198.489C892.132 201.328 892.891 203.73 893.975 205.695C895.276 207.66 897.12 209.189 899.506 210.281C901.891 211.154 905.144 211.591 909.265 211.591C911.868 211.591 914.47 211.591 917.073 211.591C919.675 211.373 922.278 210.936 924.88 210.281V239.104C920.76 239.541 916.748 239.978 912.844 240.414C908.94 240.851 904.928 241.07 900.807 241.07C891.047 241.07 883.131 240.196 877.059 238.449C871.203 236.484 866.54 233.754 863.07 230.261C859.817 226.549 857.54 221.963 856.238 216.504C855.154 211.045 854.503 204.822 854.286 197.834V97.9345H826.309V70.0936Z"
              fill="#F6F2E6" />
            <path
              d="M941.8 70.0936H976.934V94.9866L977.585 95.6417C983.223 86.2522 990.597 78.9372 999.706 73.6965C1008.82 68.2375 1018.9 65.508 1029.96 65.508C1048.4 65.508 1062.93 70.3119 1073.55 79.9198C1084.18 89.5276 1089.49 103.939 1089.49 123.155V239.432H1052.41V132.981C1051.97 119.661 1049.15 110.053 1043.95 104.158C1038.74 98.0437 1030.61 94.9866 1019.55 94.9866C1013.26 94.9866 1007.62 96.1876 1002.63 98.5896C997.646 100.773 993.417 103.939 989.947 108.088C986.477 112.019 983.766 116.713 981.814 122.172C979.862 127.631 978.886 133.418 978.886 139.532V239.432H941.8V70.0936Z"
              fill="#F6F2E6" />
            <path
              d="M1234.33 139.86C1233.9 133.964 1232.6 128.287 1230.43 122.828C1228.48 117.369 1225.66 112.674 1221.97 108.743C1218.5 104.594 1214.16 101.319 1208.96 98.9171C1203.97 96.2968 1198.33 94.9866 1192.04 94.9866C1185.53 94.9866 1179.57 96.1876 1174.15 98.5896C1168.94 100.773 1164.39 103.939 1160.48 108.088C1156.8 112.019 1153.76 116.713 1151.38 122.172C1149.21 127.631 1148.01 133.527 1147.8 139.86H1234.33ZM1147.8 164.425C1147.8 170.976 1148.66 177.308 1150.4 183.422C1152.35 189.537 1155.17 194.886 1158.86 199.472C1162.55 204.057 1167.21 207.77 1172.85 210.608C1178.49 213.229 1185.21 214.539 1193.02 214.539C1203.86 214.539 1212.54 212.246 1219.04 207.66C1225.77 202.856 1230.75 195.76 1234.01 186.37H1269.14C1267.19 195.541 1263.83 203.73 1259.06 210.936C1254.28 218.142 1248.54 224.256 1241.81 229.278C1235.09 234.082 1227.5 237.685 1219.04 240.087C1210.8 242.707 1202.13 244.017 1193.02 244.017C1179.79 244.017 1168.08 241.834 1157.88 237.467C1147.69 233.099 1139.01 226.985 1131.86 219.124C1124.92 211.263 1119.6 201.874 1115.92 190.956C1112.45 180.038 1110.71 168.028 1110.71 154.926C1110.71 142.917 1112.55 131.562 1116.24 120.862C1120.15 109.944 1125.57 100.446 1132.51 92.3663C1139.66 84.0686 1148.23 77.5178 1158.21 72.7139C1168.18 67.91 1179.46 65.508 1192.04 65.508C1205.27 65.508 1217.09 68.3467 1227.5 74.0241C1238.13 79.4831 1246.91 86.7981 1253.85 95.9692C1260.79 105.14 1265.78 115.731 1268.82 127.741C1272.07 139.532 1272.94 151.76 1271.42 164.425H1147.8Z"
              fill="#F6F2E6" />
            <path
              d="M1289.85 70.0936H1324.66V102.848H1325.31C1326.4 98.262 1328.46 93.7856 1331.49 89.4184C1334.75 85.0512 1338.54 81.1208 1342.88 77.627C1347.43 73.9149 1352.42 70.967 1357.84 68.7834C1363.27 66.5998 1368.8 65.508 1374.44 65.508C1378.77 65.508 1381.7 65.6172 1383.22 65.8356C1384.95 66.0539 1386.69 66.2723 1388.42 66.4906V102.52C1385.82 102.083 1383.11 101.756 1380.29 101.537C1377.69 101.101 1375.09 100.882 1372.48 100.882C1366.19 100.882 1360.23 102.193 1354.59 104.813C1349.17 107.215 1344.4 110.927 1340.28 115.949C1336.16 120.753 1332.9 126.758 1330.52 133.964C1328.13 141.17 1326.94 149.467 1326.94 158.857V239.432H1289.85V70.0936Z"
              fill="#F6F2E6" />
            <path
              d="M1422.44 185.06C1423.52 195.978 1427.64 203.621 1434.8 207.988C1441.96 212.355 1450.53 214.539 1460.5 214.539C1463.97 214.539 1467.88 214.32 1472.21 213.884C1476.77 213.229 1481 212.137 1484.9 210.608C1488.8 209.08 1491.95 206.896 1494.34 204.057C1496.94 201 1498.13 197.07 1497.91 192.266C1497.7 187.462 1495.96 183.532 1492.71 180.475C1489.46 177.418 1485.23 175.016 1480.02 173.269C1475.03 171.303 1469.29 169.666 1462.78 168.356C1456.27 167.045 1449.66 165.626 1442.93 164.098C1435.99 162.569 1429.27 160.713 1422.77 158.529C1416.48 156.346 1410.73 153.398 1405.52 149.686C1400.54 145.974 1396.52 141.279 1393.49 135.602C1390.45 129.706 1388.93 122.5 1388.93 113.984C1388.93 104.813 1391.1 97.1702 1395.44 91.0561C1399.99 84.7237 1405.63 79.7014 1412.35 75.9893C1419.3 72.0588 1426.89 69.3293 1435.13 67.8008C1443.59 66.2723 1451.61 65.508 1459.2 65.508C1467.88 65.508 1476.12 66.4906 1483.93 68.4559C1491.95 70.2028 1499.11 73.1506 1505.4 77.2994C1511.9 81.4483 1517.22 86.9073 1521.34 93.6765C1525.67 100.227 1528.39 108.197 1529.47 117.587H1490.76C1489.02 108.634 1484.9 102.629 1478.39 99.5722C1472.11 96.5151 1464.84 94.9866 1456.6 94.9866C1454 94.9866 1450.85 95.205 1447.16 95.6417C1443.69 96.0784 1440.33 96.9519 1437.08 98.262C1434.04 99.3538 1431.44 101.101 1429.27 103.503C1427.1 105.686 1426.02 108.634 1426.02 112.346C1426.02 116.932 1427.54 120.644 1430.57 123.483C1433.83 126.321 1437.95 128.723 1442.93 130.688C1448.14 132.435 1454 133.964 1460.5 135.274C1467.01 136.584 1473.73 138.004 1480.67 139.532C1487.4 141.061 1494.01 142.917 1500.52 145.1C1507.02 147.284 1512.77 150.232 1517.76 153.944C1522.96 157.656 1527.08 162.351 1530.12 168.028C1533.37 173.705 1535 180.693 1535 188.991C1535 199.035 1532.72 207.551 1528.17 214.539C1523.61 221.526 1517.65 227.204 1510.28 231.571C1503.12 235.938 1495.09 239.104 1486.2 241.07C1477.31 243.035 1468.53 244.017 1459.85 244.017C1449.22 244.017 1439.36 242.816 1430.25 240.414C1421.36 238.012 1413.55 234.41 1406.82 229.606C1400.32 224.583 1395.11 218.469 1391.21 211.263C1387.52 203.839 1385.57 195.105 1385.35 185.06H1422.44Z"
              fill="#F6F2E6" />
          </svg>
        </v-col>
      </v-row>

    </v-container>

  </v-footer>
</template>

<script>
import { useLocale } from "vuetify";
import { mapGetters } from 'vuex'

export default {
  name: "FooterComponent",
  data: () => ({
    list3: [
      {
        title: "Living real estate",
        href: "#"
      },
      {
        title: "Residential complexes",
        href: "#"
      },
      {
        title: "Land property",
        href: "#"
      },
      {
        title: "Industrial real estate",
        href: "#"
      },
      {
        title: "Foreign real estate",
        href: "#"
      },
      {
        title: "Commercial property",
        href: "#"
      },
    ],
    list4: [
      {
        title: "copyrights",
        params: "copyrights"
      },
      {
        title: "legal_person",
        params: "legal"
      },
      {
        title: "terms_and_condition",
        params: "terms"
      },
      {
        title: "sitemap",
        params: ""
      },
    ]
  }),
  setup() {
    const { t } = useLocale();
    return {
      t,
    };
  },
  computed: {
    ...mapGetters([
      'getAllCategories',
    ])
  },
  async mounted() {
    await this.$store.dispatch('LoadAllCategories');
  },
  methods: {
    GetPath(name) {
      switch (name) {
        case "home":
          return {
            name: 'home',
            params: { lang: this.$vuetify.locale.current }
          };
        case "real-estate":
          return {
            name: 'real-estate',
            params: {
              lang: this.$vuetify.locale.current,
              categorie: ""
            }
          };
        case "about":
          return {
            name: 'about',
            params: {
              lang: this.$vuetify.locale.current,
            }
          }
        case "learn":
          return {
            name: 'learn',
            params: {
              lang: this.$vuetify.locale.current,
            }
          };
        case "partners":
          return {
            name: 'partners',
            params: {
              lang: this.$vuetify.locale.current,
            }
          };
        case "contact":
          return {
            name: 'contact',
            params: {
              lang: this.$vuetify.locale.current,
            }
          }
        default:
          return {
            name: 'home',
            params: { lang: this.$vuetify.locale.current }
          };
      }
    },
    SelectCategory(categorie) {
      this.$router.push({ name: 'real-estate', params: { categorie: categorie[`link_${this.$vuetify.locale.current}`], lang: this.$route.params.lang } })
    },
    OpenLegalPage(item) {
      this.$router.push({
        name: "legal",
        params: {
          lang: this.$vuetify.locale.current,
          name: item.params
        }
      })
    }
  }
};
</script>

<style scoped>
.text-gold {
  color: #CC8702;
  letter-spacing: -0.01rem;
  white-space: normal,
}

.list3 {
  background: transparent;
  padding: 0px;
}

.list3-item {
  min-height: 8px;
  width: auto;
  border-radius: 8px;
}

.list3-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.list3-item-title {
  color: #9A9A9B;
  letter-spacing: -0.01rem;
  font-size: 0.9rem;
}

.list2 {
  background: transparent;
  padding: 0px;
}

.list2-item {
  min-height: 44px;
  width: auto;
  border-radius: 8px;
}

.list2-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.list2-item-title {
  color: #F6F2E6;
  letter-spacing: -0.02rem;
  font-size: 1.4rem;
}

.span-line-verticaly {
  padding-top: 3px;
  color: #9A9A9B;
}

.text-footer-small {
  height: auto;
  color: #9A9A9B;
  letter-spacing: -0.01rem;
  font-size: 0.9rem;
}

.btn-small {
  color: #9A9A9B;
  text-transform: inherit;
  letter-spacing: -0.01rem;
}

.btn-svg-scroll-top {
  border-radius: 30px;
}

.btn-svg-scroll-top:hover {
  background: #F6F2E6;
}

.btn-svg-scroll-top:hover .svg-path {
  fill: #06080A;
}

.div-blur {
  width: 250px;
  height: 250px;
  position: absolute;
  bottom: -5%;
  left: -5%;
  background: #F6F2E6;
  filter: blur(250px);
  -webkit-filter: blur(250px);
  -moz-filter: blur(250px);
  will-change: transform;
}

.footer-block {
  width: 100%;
  background: #06080A;
  position: relative;
  overflow: hidden;
}

@media screen and (max-width: 600px) {

  .list2-item {
    min-height: 32px;
  }

  .list2-item-title {
    letter-spacing: -0.015rem;
    font-size: 1.2rem;
  }

  .text-gold {
    letter-spacing: -0.015rem;
    font-size: .9rem;
  }
}
</style>